import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

var groups_json= "https://raw.githubusercontent.com/yovavsanders/govmap/master/atlas/groups.json";

export const store = new Vuex.Store({
  state: {

    turnOnLayers: [],
    turnOffLayers: [],

    clickMapMessage: false,
    showLayerInfo: false,

    LayerNameInfo: "",
    iconText: 'message-text',
    groups: [],
    

    minhali: [
      {
        text: 'נפה',
        layer_name: 'sites_napot_prod',
        symbol_field: 'nafa'
      },

      {
        text: 'מחוז',
        layer_name: 'sites_mahozot_prod',
        symbol_field: 'MAHOZ'

      },
      {
        text: 'אזורים טבעיים',
        layer_name: 'sites_natural_area_prod',
        symbol_field: 'HEB_NAME'

      },
    ],

  
      
    
    layers: [
        {
          text: 'האוכלוסייה לפי נפות 2015',
          layer_name: 'sites_pop_by_region',
          fields: ['CODE','HEB_NAME','ENG_NAME','PERIMETER','TOT_POP','popdensity','pop_1948','pop_1967','pop_2005'],
        },
        {
          text: 'האוכלוסייה הערבית לפי דת ולפי נפות 2015',
          layer_name: 'sites_arab_pop_by_religion',
          fields: ['HEB_NAME','ENG_NAME','Muslim','Christian','Druze','Arab','F2015All']
        },
        {
          text: 'האוכלוסייה לפי אזורים טבעיים 2015',
          layer_name: 'sites_pop_by_natural_areas',
          fields: ['CODE','HEB_NAME','ENG_NAME','ARAB_POP','TO_JEW_PO','TO_JEW_OTH','TOT_POP','TO_UNJE_LO','TO_JEW_LO','TOT_LOCA','popdensity']
        },

        // {
        //   text: 'האוכלוסייה לפי מחוזות 2015',
        //   layer_name: 'sites_pop_by_mahoz',
        //   fields: ['District','SUM_ARAB_P','SUM_TO_JEW','SUM_TOT_PO']
        // },
      ],

    layer_index: -1,
    city_index: -1,
    minhali_index: -1,
    layer__trans_index: -1,
    layer__rails_index: -1,
    selected_data_reg: [],
    selected_data_arab: [],
    selected_data_natural: [],
    selectedLayer: null,
    selectedCityLayer: null,
    selectedTransLayer: null,
    selectedMinhaliLayer: null,
    img: "",
    selectedlayers: []
    
  },
  mutations: { //Mutations are like setters
    SET_GROUPS: (state, groups) => { //capitalization is good-practice for vuex-mutations
        state.groups = groups;
    }
}
})

const setProductToStore = () => {

  axios
  .get(groups_json)
  .then(response => {
      store.commit('SET_GROUPS', response.data.groups);
  })   
}

setProductToStore();

